<ng-container *ngIf="ctx" [ngSwitch]="mainService.getShopPortalLayoutKind()">
  <app-rims-overview-boxed-layout *ngSwitchDefault [ctx]="ctx"></app-rims-overview-boxed-layout>
  <app-rims-overview-scroll-layout *ngSwitchCase="1" [ctx]="ctx" ></app-rims-overview-scroll-layout>
</ng-container>
